import { getRequest } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
import type { Auth } from "./auth";
import auth from "./auth";
const api = getApiWithVersion(API_VERSION.V2);
export interface API_V2 {
  getAboutUs(): Promise<any>;
  auth:Auth

}

const api_v2: API_V2 = {
  getAboutUs() {
    return getRequest(api.FEEDBACK_ABOUT_US);
  },
  auth:auth
};

export default api_v2;
